// extracted by mini-css-extract-plugin
export var container = "_7i-0";
export var icon = "_7i-1";
export var text = "_7i-2";